<div>
  @switch (criterionFilterInputType) {
    @case (searchCriteriaInputType.INPUT_TEXT_NUMBER) {
      <app-input-criteria-text
        [searchCriteriaTextChange]="searchCriteriaChange"
        (searchCriteriaTextReset)="searchCriteriaResetHandler()"
      [isInputTypeNumber]="true"></app-input-criteria-text>
    }
    @case (searchCriteriaInputType.INPUT_TEXT_STRING) {
      <app-input-criteria-text
        [searchCriteriaTextChange]="searchCriteriaChange"
        (searchCriteriaTextReset)="searchCriteriaResetHandler()"
      [isInputTypeNumber]="false"></app-input-criteria-text>
    }
    @case (searchCriteriaInputType.INPUT_DATE) {
      <app-input-criteria-date
        [searchCriteriaDateChange]="searchCriteriaChange"
      (searchCriteriaDateReset)="searchCriteriaResetHandler()"></app-input-criteria-date>
    }
    @case (searchCriteriaInputType.INPUT_CURRENCY) {
      <app-input-criteria-currency
        [searchCriteriaCurrencyChange]="searchCriteriaChange"
      (searchCriteriaCurrencyReset)="searchCriteriaResetHandler()"></app-input-criteria-currency>
    }
    @case (searchCriteriaInputType.INPUT_MULTI_SELECTION) {
      <app-input-criteria-multi-selection
        [globalSearchCriteriaModel]="globalSearchCriteriaModel"
        [searchCriteriaMultiSelectChange]="searchCriteriaChange"
      (searchCriteriaMultiSelectReset)="searchCriteriaResetHandler()"></app-input-criteria-multi-selection>
    }
    @case (searchCriteriaInputType.INPUT_AUTOCOMPLETE_MULTI_SELECTION) {
      <app-input-criteria-autocomplete-multi-selection
        [globalSearchCriteriaModel]="globalSearchCriteriaModel"
        (searchCriteriaAutocompleteMultiSelectionReset)="searchCriteriaResetHandler()">
      </app-input-criteria-autocomplete-multi-selection>
    }
  }
</div>
